import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input
} from "@angular/core";

import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
  selector: "app-loading",
  templateUrl: "./loading.component.html",
  imports: [MatProgressSpinner],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingComponent implements OnInit {
  text = input<string | undefined>();
  // size in pixels. Will apply to width and height
  size = input<number | undefined>();

  constructor() {}

  ngOnInit(): void {}
}
